import Whiteboard from "components/whiteboard/Whiteboard";
import React from "react";

const WhiteboardContainer = () => {
  return (
    <>
      <Whiteboard />
    </>
  );
};

export default WhiteboardContainer;
